export const USER_NOTIFICATION_ROLE_NAMES = new Set([
  "Super Admin",
  "Super User",
  "Support Admin",
  "Customer Support",
  "Fleet Admin",
]);

export const GLOBAL_ORDER_NOTIFICATION_ROLE_NAMES = new Set([
  "Super Admin",
  "Super User",
  "Customer Support",
]);

const normalizeRoleName = (roleName?: string | null) =>
  String(roleName ?? "").trim().replace(/\s+/g, " ").toLowerCase();

const includesNormalized = (roles: Set<string>, roleName?: string | null) => {
  const normalized = normalizeRoleName(roleName);
  return Array.from(roles).some((role) => normalizeRoleName(role) === normalized);
};

export const isUserNotificationRole = (
  roleName?: string | null,
  notificationScope?: string | null,
) =>
  notificationScope === "user" ||
  includesNormalized(USER_NOTIFICATION_ROLE_NAMES, roleName);

export const isGlobalOrderNotificationRole = (roleName?: string | null) =>
  includesNormalized(GLOBAL_ORDER_NOTIFICATION_ROLE_NAMES, roleName);
